"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var hooks_1 = require("utils/hooks");
var StringFieldSubmitter = function (_a) {
    var // TO CONFIRM
    item = _a.item, field = _a.field, collection = _a.collection, onSubmit = _a.onSubmit;
    var _b = __read(react_1.default.useState((item[field] || '')), 2), value = _b[0], setValue = _b[1];
    var _c = __read((0, hooks_1.useSubmitter)(collection, item.id), 2), submit = _c[0], isSubmitting = _c[1];
    var inputRef = react_1.default.useRef(null);
    react_1.default.useEffect(function () {
        if (inputRef.current)
            inputRef.current.focus();
    }, [!!inputRef.current]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("input", { onChange: function (e) { return setValue((e.currentTarget || e.target).value); }, value: value, ref: inputRef }), (0, jsx_runtime_1.jsxs)(Button_1.default, __assign({ onClick: function () {
                    var _a;
                    return submit((_a = {}, _a[field] = value, _a)).then(onSubmit);
                }, isSending: isSubmitting, disabled: !value }, { children: ["Submit", isSubmitting && 'ting'] }))] }));
};
exports.default = StringFieldSubmitter;
